import { Group, IconFont, singleTextEllipsis } from '@byecode/ui'
import { Checkbox } from '@mantine/core'
import styled, { css } from 'styled-components'

export const Container = styled.div`
    width: 100%;
`

export const FormItemLabelWrapper = styled.div`
    position: relative;
    width: 100%;
    margin-right: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    gap: 4px;
`

export const FormItemLabel = styled.span<{ required?: boolean }>`
    position: relative;
    ${({ required }) =>
        required &&
        css`
            &::after {
                content: '*';
                position: absolute;
                top: 0;
                right: -12px;
                color: var(--color-red-500);
            }
        `}
`

export const FormItemContent = styled.div`
    flex-shrink: 0;
    width: 180px;
`

export const FlexBetween = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: row nowrap;
`

export const FlexStart = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: row nowrap;
`

export const CheckItem = styled(Checkbox)`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    height: 40px;
    border-radius: 8px;
    background-color: var(--color-gray-100);
    padding: 12px 14px;
`

export const Title = styled.div`
    color: var(--color-black);
    font-size: var(--font-size-normal);
    font-weight: var(--font-weight-normal);
`

interface IconProps {
    mr?: number
}

export const Icon = styled(IconFont)<IconProps>`
    margin-right: 6px;
    margin-right: ${({ mr }) => mr ?? 0}px;
`

export const Check = styled(Checkbox)`
    display: flex;
    align-items: center;
    color: var(--color-black);
    font-weight: var(--font-weight-normal);
`

export const CheckboxGroup = styled(Checkbox.Group)`
    & .mantine-InputWrapper-label {
        width: 100%;
    }
`

export const Tip = styled.div`
    padding: 0 8px;
    font-size: var(--font-size-sm);
    color: var(--color-gray-400);
    margin: 4px 0;
    line-height: 20px;
`

export const LastContent = styled.div`
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 8px;
    height: 36px;
    display: flex;
    align-items: center;
    border: 1px solid var(--color-gray-200);
    background-color: var(--color-gray-100);
    padding: 0 30px;
`

export const LastContentIndex = styled.div`
    font-style: normal;
    word-break: break-word;
    margin-right: 6px;
    ${singleTextEllipsis};
    display: inline-block;
    min-width: 40px;
    font-size: 12px;
    color: var(--color-gray-600);
    background: var(--color-white);
    border: 1px solid var(--color-gray-200);
    border-radius: 4px;
    line-height: 22px;
    padding: 1px 4px;
`

export const LastContentTitle = styled.div`
    color: var(--color-gray-900);
    font-size: 14px;
    font-weight: 400;
`

export const Label = styled.div``

export const Text = styled.span`
    font-size: 14px;
    color: red;
    padding-left: 4px;
    font-weight: normal;
`

export const ActionGroup = styled(Group)``

export const FieldList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 8px;
    padding: 0 8px;
`

export const FieldTitle = styled.div<{ required?: boolean }>`
    height: 22px;
    line-height: 22px;
    font-size: 14px;

    position: relative;
    ${({ required }) =>
        required &&
        css`
            &::after {
                content: '*';
                position: absolute;
                top: 0;
                right: -12px;
                color: var(--color-red-500);
            }
        `}
`

export const FieldItem = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 6px;
`

export const OptionItem = styled.div`
    padding: 10px 16px;
    word-break: break-all;
    cursor: pointer;
    font-size: 14px;
    &:hover {
        background-color: var(--color-gray-100);
    }
    &[data-disable='true'] {
        opacity: 0.6;
        cursor: not-allowed;
    }
`
